import { render, staticRenderFns } from "./SrDropzoneUpload.vue?vue&type=template&id=2e39eeb8"
import script from "./SrDropzoneUpload.vue?vue&type=script&lang=js"
export * from "./SrDropzoneUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports